
import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { getEmployerInfo } from '@/utils/authUtils';
import { RefreshCw } from 'lucide-react';

interface ProtectedEmployerRouteProps {
  children: ReactNode;
}

const ProtectedEmployerRoute = ({ children }: ProtectedEmployerRouteProps) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuthorization = () => {
      // For employers, check if their info exists in sessionStorage
      const employerInfo = getEmployerInfo();
      
      if (!employerInfo) {
        toast.error('Please sign in as an employer to access this page');
        setIsAuthorized(false);
        return;
      }
      
      setIsAuthorized(true);
    };

    checkAuthorization();
  }, []);

  if (isAuthorized === null) {
    // Still checking authorization
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <RefreshCw className="animate-spin h-12 w-12 text-apple-blue" />
          <p className="text-apple-text-secondary">Verifying authorization...</p>
        </div>
      </div>
    );
  }

  return isAuthorized 
    ? <>{children}</> 
    : <Navigate to="/employer-login" state={{ from: location }} replace />;
};

export default ProtectedEmployerRoute;
